export const validEmail = (emailAddress) => {
  if (!emailAddress) return false;
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return regex.test(emailAddress);
};
